
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Inventory, InventoryBin, InventoryBinMapping, InventoryUiClient } from '../../../../backend/backendapi';
import { handleError, initClient } from '../../../../../api';
import BinEntry from './TabInventoryBins/BinEntry';
import CenterOnParent from '../../../../util/CenterOnParent';
import Spinner from '../../../../util/Spinner';

@Component({
  components: { BinEntry, CenterOnParent, Spinner },
})
export default class TabInventoryBins extends Vue {
  @Prop({ required: true })
  readonly inventory!: Inventory | null;

  readonly api = initClient(InventoryUiClient);
  readonly bins: InventoryBin[] = [];
  loading = false;

  get binsById(): Map<string, InventoryBin> {
    return new Map(this.bins.map(e => [e.id, e]));
  }

  get binsForDisplay(): { mapping: InventoryBinMapping, bin: InventoryBin | undefined } [] {
    if (!this.inventory) {
      return [];
    }
    return this.inventory?.bins?.map(e => ({ mapping: e, bin: this.binsById.get(e.binId) })) ?? [];
  }

  @Watch('inventory.bins', { deep: true })
  private async onInventoryBinsChanged(): Promise<void> {
    this.bins.splice(0);

    // any bin info required?
    if (!this.inventory?.bins?.length) {
      return;
    }

    // load relevant bins
    this.loading = true;
    try {
      const bins = await this.api.listBins(this.inventory?.bins?.map(e => e.binId) ?? []);
      this.bins.push(...bins);
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    } finally {
      this.loading = false;
    }
  }
}
